import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import HowItWorks from "@/pages/HowItWorks";
import About from "@/pages/About";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import ServiceArea from "@/pages/ServiceArea";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Pricing from "@/pages/Pricing";
import Locations from "@/pages/Locations";
import { PrivacyPolicy, TermsOfService, Disclaimer } from "@/pages/Legal";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { AuthProvider } from "@/contexts/AuthContext";
import { RegionProvider } from "@/contexts/RegionContext";

const PublicPage = ({ children }) => <Layout>{children}</Layout>;

function App() {
  return (
    <AuthProvider>
      <RegionProvider>
        <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/" element={<PublicPage><Home /></PublicPage>} />
          <Route path="/services" element={<PublicPage><Services /></PublicPage>} />
          <Route path="/how-it-works" element={<PublicPage><HowItWorks /></PublicPage>} />
          <Route path="/about" element={<PublicPage><About /></PublicPage>} />
          <Route path="/faq" element={<PublicPage><FAQ /></PublicPage>} />
          <Route path="/contact" element={<PublicPage><Contact /></PublicPage>} />
          <Route path="/blog" element={<PublicPage><Blog /></PublicPage>} />
          <Route path="/blog/:slug" element={<PublicPage><BlogPost /></PublicPage>} />
          <Route path="/pricing" element={<PublicPage><Pricing /></PublicPage>} />
          <Route path="/locations" element={<PublicPage><Locations /></PublicPage>} />
          <Route path="/privacy-policy" element={<PublicPage><PrivacyPolicy /></PublicPage>} />
          <Route path="/terms-of-service" element={<PublicPage><TermsOfService /></PublicPage>} />
          <Route path="/disclaimer" element={<PublicPage><Disclaimer /></PublicPage>} />
          <Route path="/service-areas/:slug" element={<PublicPage><ServiceArea /></PublicPage>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="*" element={<PublicPage><Home /></PublicPage>} />
        </Routes>
      </BrowserRouter>
      </RegionProvider>
    </AuthProvider>
  );
}

export default App;
